export const CITY = 'CITY';
export const COUNTRY = 'COUNTRY';
export const HOTEL = 'HOTEL';